import React, { useEffect, useState } from 'react';
import { api } from '../api';
import { X, Megaphone } from 'lucide-react';

const AnnouncementBar = () => {
  const [data, setData] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get('/settings/announcement').then((r) => setData(r.data)).catch(() => setData(null));
    const key = 'trucrunch_ann_dismissed';
    if (sessionStorage.getItem(key)) setDismissed(true);
  }, []);

  if (!data || !data.enabled || !data.text || dismissed) return null;

  const close = () => {
    sessionStorage.setItem('trucrunch_ann_dismissed', '1');
    setDismissed(true);
  };

  return (
    <div className="fixed top-0 inset-x-0 z-[80] bg-gradient-to-r from-[#E63946] via-[#F4A300] to-[#FFD84D] text-[#1a1a1a] text-sm font-brico font-bold">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-3 relative">
        <Megaphone size={16} className="flex-shrink-0" />
        <span className="truncate text-center">{data.text}</span>
        {data.link && data.link_label && (
          <a href={data.link} className="underline underline-offset-2 hover:no-underline whitespace-nowrap">{data.link_label} →</a>
        )}
        <button onClick={close} className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded-full hover:bg-black/10" aria-label="Dismiss">
          <X size={14} />
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBar;
